import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import CircularProgress from './../../../../components/CircularProgress';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import moment from 'moment';
import { toast } from 'react-toastify';
import PaginationComponent from './../../../common/Pagination';
import { GET_REPORT_DATA, MARK_IGNORED_DATA, Revert_Ignored_DATA } from '../../../../appRedux/actions/ReportDetailAction';
import { ReportType, numberWithCommas, makeLinkForQuickbooks, ModuleType, LinkType } from '../../../common/commonServices';
import CommonComments from './../../../common/Comments';
import './DataEntryIssues.css';
import './TrainingTipTables.css';

// UseTransferDataEntryScreen (ReportType 51) — Got It ignore only, no QBO writes
class UseTransferDataEntryScreen extends Component {

    constructor(props) {
        super(props);

        this.state = {
            parantData: this.props.location.state ? this.props.location.state : null,
            MissingData: [],
            companyId: 0,
            sortField: 'date',
            sortFormat: "D",
            PageNo: 1,
            PageSize: 10,
            ColorCode: "#e27b40",
            sDate: new Date(2019, 0, 1),
            eDate: new Date(),
            loading: false,
            TotalRecords: 0,
            CommentReferenceId: 0,
            IsEmbeddedPage: false,
            SelectedRecords: [],
            SelectALL: false,
            IsIgnoredFilter: false
        }
    }

    onCheckboxClick = (e, item) => {
        e.stopPropagation();

        let existInArray = false;
        let data = this.state.SelectedRecords;
        if (data != null && data.length > 0 && data.indexOf(item.id) > -1) {
            existInArray = true;
        }

        if (e.target.checked) {
            if (!existInArray) {
                data.push(item.id);
            }
        }
        else {
            if (existInArray) {
                data.splice(data.indexOf(item.id), 1);
            }
        }

        let all = (data.length == this.state.MissingData.length) ? true : false;
        this.setState({ SelectedRecords: data, SelectALL: all });
    }

    SelectALL = (e) => {
        if (this.state.MissingData.length > 0) {
            if (e.target.checked) {
                let all = [];
                let data = this.state.MissingData;
                for (let i = 0; i < data.length; i++) {
                    all.push(data[i].id);
                }
                this.setState({ SelectALL: true, SelectedRecords: all });
            }
            else {
                this.setState({ SelectALL: false, SelectedRecords: [] });
            }
        }
    }

    OnApplyIgnore = () => {
        let selectedData = this.state.SelectedRecords;
        if (selectedData == null || selectedData.length === 0) {
            toast.error("Please select atleast 1 record for processing request");
            return false;
        }

        // Got It → MarkAsIgnore; Revert → remove ignore — ReportType 51 only (no QBO writes)
        let body = {
            "ids": selectedData,
            "reportType": ReportType.UseTransferDataEntryScreen,
            "companyID": this.state.companyId
        }

        this.setState({ loading: true }, () => {
            if (this.state.IsIgnoredFilter) {
                this.props.Revert_Ignored_DATA(body);
            }
            else {
                this.props.MARK_IGNORED_DATA(body);
            }
        });
    }

    componentDidMount() {
        let user = JSON.parse(localStorage.getItem('userData'));
        this.setState({
            companyId: user.companyId,
            loading: true
        }, () => {
            this.GetReportData();
        });
    }

    onLinkClick = (rowData) => {
        let origin = makeLinkForQuickbooks();
        window.open(origin + rowData.transactionLink);
    }

    LoadComments = (item) => {
        this.setState({ IsCommentModelOpen: true, CommentReferenceId: item.id });
    }

    UpdateItemCommentCount = (id, clearUnread) => {
        let data = this.state.MissingData;
        data.forEach(function (item) {
            if (item.id === id) {
                // clearUnread=true zeros the badge after the comment modal is closed or reviewed
                if (clearUnread === true) { item.unreviewCommentCount = 0; } else { item.commentCount++ }
            }
        });
        this.setState({ MissingData: data });
    }

    CloseComments = () => {
        this.setState({ IsCommentModelOpen: false });
    }

    onSortChange = (fieldName) => {
        if (this.state.sortField === fieldName) {
            let formate = this.state.sortFormat === 'A' ? 'D' : 'A';
            this.setState({ sortFormat: formate, loading: true }, () => {
                this.GetReportData();
            });
        } else {
            this.setState({ sortField: fieldName, sortFormat: 'A', loading: true }, () => {
                this.GetReportData();
            });
        }
    }

    // Refresh Data disabled for Transfer DEI (keep for rollback).
    // onRefreshDataClick = () => {
    //     if (!this.state.loading) {
    //         this.setState({ loading: true }, () => {
    //             this.GetReportData(true);
    //         });
    //     }
    // }

    ChangePageSize = (size) => {
        this.setState({
            loading: true, PageSize: parseInt(size), PageNo: 1, SelectedRecords: [],
            SelectALL: false
        }, () => {
            this.GetReportData();
        });
    }

    ChangePage = (page) => {
        this.setState({
            loading: true, PageNo: page, SelectedRecords: [],
            SelectALL: false
        }, () => {
            this.GetReportData();
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.ReportData !== this.props.ReportData) {
            if (nextProps.ReportData.transactionStatus === 0) {
                var totalrecords = 0;
                if (nextProps.ReportData.returnObject != null && nextProps.ReportData.returnObject.length > 0) {
                    totalrecords = nextProps.ReportData.returnObject[0].totalrows
                }
                this.setState({ MissingData: nextProps.ReportData.returnObject, TotalRecords: totalrecords, PageSize: this.state.PageSize, PageNo: this.state.PageNo, loading: false, SelectALL: false, SelectedRecords: [] });
            } else {
                toast.error(nextProps.ReportData.resultMsg);
                this.setState({ loading: false });
            }
        }

        if (nextProps.UpdateDescription !== this.props.UpdateDescription) {
            if (nextProps.UpdateDescription.transactionStatus === 0) {
                this.setState({
                    loading: true, SelectALL: false, SelectedRecords: []
                }, () => {
                    toast.success(`${nextProps.UpdateDescription.resultMsg}`);
                    this.GetReportData();
                });
            }
            else {
                this.setState({ loading: false }, () => {
                    toast.error(`${nextProps.UpdateDescription.resultMsg}`);
                });
            }
        }
    }

    GetReportData = (IsRefresh = false) => {
        let state = this.state;
        let body = {
            companyID: state.companyId,
            reportType: ReportType.UseTransferDataEntryScreen,
            fromDate: moment(state.sDate).format("MM/DD/YYYY"),
            toDate: moment(state.eDate).format("MM/DD/YYYY"),
            sortField: state.sortField,
            sortFormat: state.sortFormat,
            pageNumber: state.PageNo,
            pageSize: state.PageSize,
            needUpdatQBORecords: IsRefresh,
            IsIgnore: true,
            isAllIgnoreUnignore: state.IsIgnoredFilter
        };

        this.props.GET_REPORT_DATA(body);
    }

    HandleIgnored = (event) => {
        // Reset to page 1 so filter switch does not keep an out-of-range PageNo (empty result).
        this.setState({ IsIgnoredFilter: (event.target.value == "true" ? true : false), PageNo: 1, loading: true, SelectedRecords: [], SelectALL: false }, () => { this.GetReportData() });
    }

    render() {
        let selectedItem = this.state.SelectedRecords;
        return (
            <div className="dashboardPage data-entry-issues-page use-transfer-page">
                <div className="page-heading page-title-box d-sm-flex justify-content-sm-between align-items-sm-center">
                    <h2 className="mb-3 mb-sm-0">{JSON.parse(localStorage.getItem('userData')) != null ? JSON.parse(localStorage.getItem('userData')).companyName : ""} | {LinkType.UseTransferDataEntryScreen}</h2>
                </div>
                {this.state.IsCommentModelOpen ? <CommonComments
                    CloseComments={this.CloseComments}
                    ColorCode={this.state.ColorCode}
                    ModuleType={ModuleType.GeneralReportType}
                    ReportType={ReportType.UseTransferDataEntryScreen}
                    CompanyId={this.state.companyId}
                    RecordId={this.state.CommentReferenceId}
                    IsEmbeddedPage={this.state.IsEmbeddedPage}
                    UpdateItemCommentCount={this.UpdateItemCommentCount}
                    SilentRefreshData={() => { if (typeof this.GetReportData === "function") { this.GetReportData(false); } }}
                ></CommonComments> : ""}
                {this.state.loading ? <div className="dei-loader-box"><CircularProgress /></div>
                    :
                    <React.Fragment>
                        <div className="padding-box app-wrapper">
                            <div className="row mt-1">
                                <div className="col-md-7">
                                    <div className="dei-tip-block">
                                        <h5 className="dei-training-tip" >Be sure to use the "Transfer" transaction type when recording phone, online or wire transfers between bank accounts.</h5>
                                        <h5 className="dei-training-tip dei-tip-gap" >Using "Deposits, Expense or Check" entries for these transactions can result in duplicate transactions.</h5>
                                        <h5 className="dei-training-tip" >You do not need to change these transactions in QuickBooks Online.</h5>
                                        <h5 className="dei-training-tip" >Select the entries and click "Got it" to confirm you will make sure future transfers are recorded correctly.</h5>
                                    </div>
                                </div>
                                <div className="col-md-5">
                                    <div className='d-flex justify-content-end align-items-end h-100'>
                                        <div className='d-flex align-items-center'>
                                            <div className='show-previously-box'>
                                                <div className="form-group d-flex mb-0 align-items-center">
                                                    <h4 className="col-form-label mb-0">Show Previously Ignored Transactions:</h4>
                                                    <div className="dropdown-input-box">
                                                        <select className="dei-filter-select select-box arrow-box" onChange={this.HandleIgnored} value={this.state.IsIgnoredFilter} >
                                                            <option value={true}> YES </option>
                                                            <option value={false}> NO </option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className=''>
                                                <div className="form-group d-flex mb-0 align-items-center">
                                                    <Button variant="contained" className=" jr-btn g-teal  text-white refresh-btn graycolor" onClick={() => this.OnApplyIgnore()}>{this.state.IsIgnoredFilter ? "Revert" : "Got It"}</Button>
                                                    {/* Refresh Data button commented for Transfer DEI.
                                                    <Button variant="contained" style={{ backgroundColor: this.state.ColorCode }} className="jr-btn text-white refresh-btn" onClick={() => this.onRefreshDataClick()}  ><i className="zmdi zmdi-refresh "></i> Refresh Data</Button>
                                                    */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="table-responsive-material">
                                <table className="table tablebox account-reconcilliation use-transfer-data-entry-table">
                                    <thead>
                                        <tr style={{ backgroundColor: this.state.ColorCode }}>
                                            <th className={`td-width ${this.state.sortField === 'date' ? this.state.sortFormat === 'A'
                                                ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('date')}><p className="table-th-title">Date</p> </th>
                                            <th className={`td-width  ${this.state.sortField === 'transactionType' ? this.state.sortFormat === 'A'
                                                ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('transactionType')}><p className="table-th-title">Type</p> </th>
                                            {/* Name after Type (GL.Name). */}
                                            <th className={`td-width ${this.state.sortField === 'name' ? this.state.sortFormat === 'A'
                                                ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('name')}><p className="table-th-title">Name</p> </th>
                                            {/* From Account = payment / counterpart; To Account = categorized bank (was Account). */}
                                            <th className={`td-width ${this.state.sortField === 'fromAccount' ? this.state.sortFormat === 'A'
                                                ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('fromAccount')}><p className="table-th-title">From Account</p> </th>
                                            <th className={`td-width ${this.state.sortField === 'account' ? this.state.sortFormat === 'A'
                                                ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('account')}><p className="table-th-title">To Account</p> </th>
                                            <th className={`td-width  text-right ${this.state.sortField === 'amount' ? this.state.sortFormat === 'A'
                                                ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('amount')}><p className="table-th-title">Amount</p> </th>
                                            <th className={`td-width ${this.state.sortField === 'memoOrDescription' ? this.state.sortFormat === 'A'
                                                ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('memoOrDescription')}><p className="table-th-title">Memo/Description</p> </th>
                                            <th className={`td-width text-center ${this.state.sortField === 'reconciledThrough' ? this.state.sortFormat === 'A'
                                                ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('reconciledThrough')}><p className="table-th-title">Reconciled</p> </th>
                                            <th className="text-center">
                                                <label className="container101 header-check">
                                                    <input className="second-check-box" type="checkbox" checked={!!this.state.SelectALL} onChange={(e) => this.SelectALL(e)} />
                                                    <span className="checkmark101 yellowMark white_border"></span>
                                                </label>
                                            </th>
                                            <th className="text-center">
                                                <div className="panel-commentCount">
                                                    <img src="/vendors/WhiteCommnet.png" alt="comments" />
                                                </div>
                                            </th>
                                            <th className="text-center"><img src="/vendors/Link-arrow_header.png" alt="link" /></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.MissingData && this.state.MissingData.length > 0 ?
                                            this.state.MissingData.map((item, j) => (
                                                <tr key={j}>
                                                    <td title={item.date || ''}>{item.date}</td>
                                                    <td title={item.transactionType || ''}>{item.transactionType}</td>
                                                    <td title={item.name || ''}>{item.name}</td>
                                                    <td title={item.fromAccount || ''}>{item.fromAccount}</td>
                                                    <td title={item.account || ''}>{item.account}</td>
                                                    <td className="text-right" title={item.amount != null ? String(item.amount) : ''}>{numberWithCommas(item.amount)}</td>
                                                    <td title={item.memoOrDescription || ''}>{item.memoOrDescription}</td>
                                                    {/* Show Yes if Clr=R (reconciled), else No (cleared / no status). Center-aligned. */}
                                                    <td className="text-center" title={item.reconciledThrough || 'No'}>{item.reconciledThrough === 'Yes' ? 'Yes' : 'No'}</td>
                                                    <td onClick={(e) => e.stopPropagation()}>
                                                        <label className="container101">
                                                            <input
                                                                className="second-check-box"
                                                                type="checkbox"
                                                                checked={!!(this.state.SelectALL || (selectedItem.length > 0 && selectedItem.indexOf(item.id) > -1))}
                                                                onChange={(e) => this.onCheckboxClick(e, item)}
                                                            />
                                                            <span className="checkmark101 green_CheckMark"></span>
                                                        </label>
                                                    </td>
                                                    <td className="text-center" onClick={(e) => e.stopPropagation()}>
                                                        <div className="panel-commentCount">
                                                            <img src="/vendors/Vector Smart Object.png" alt="comments" className={item.commentCount === 0 ? "disableCommentsOpacity" : ""} onClick={() => this.LoadComments(item)}></img>
                                                            {item.unreviewCommentCount !== 0 && <span className="badge badge-pill badge-danger ng-star-inserted">{item.unreviewCommentCount}</span>}
                                                        </div>
                                                    </td>
                                                    <td className="text-center" onClick={(e) => e.stopPropagation()}><img src="/vendors/Shape 1.png" alt="link" onClick={() => this.onLinkClick(item)}></img></td>
                                                </tr>
                                            ))
                                            :
                                            <tr>
                                                <td colSpan="11" align="center">
                                                    No issues here! Keep up the good work!
                                                </td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <PaginationComponent
                                selectedPageNo={this.state.PageNo}
                                selectedSize={this.state.PageSize}
                                TotalRecords={this.state.TotalRecords}
                                ChangePageSize={this.ChangePageSize}
                                ChangePage={this.ChangePage}
                                CurrentRecords={this.state.MissingData.length}
                            >
                            </PaginationComponent>
                        </div>
                    </React.Fragment>
                }
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        ReportData: state.ReportData.ReportData,
        UpdateDescription: state.ReportData.UpdateDescription
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        GET_REPORT_DATA,
        MARK_IGNORED_DATA,
        Revert_Ignored_DATA
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(UseTransferDataEntryScreen);
